// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "description-3jL69";
var _5 = "info-2GmZs";
var _6 = "equipment-pgk3J";
var _7 = "info_price-1vb3o";
var _8 = "titleContainer-3Vh1K";
var _9 = "baggage_wrapper-3cvEQ";
var _a = "label-3M_qy";
var _b = "price_wrapper-1me-m";
var _c = "perFlight-Kaf74";
var _d = "price_label-2mXlN";
var _e = "price_label_withPrice-JYcFC";
var _f = "price_amount-3Lnvy";
var _10 = "row-3DrTC";
var _11 = "baggage__container-2_74y";
var _12 = "baggage__container_withSlider-2EoXh";
var _13 = "baggage__slider-33H5o";
var _14 = "segmentNotice-16TkV";
var _15 = "categories-N5yF4";
var _16 = "categories__item-1U1qq";
var _17 = "category__wrapper-GwHnd";
var _18 = "category__price-1za-t";
var _19 = "category_info-PA_Rs";
var _1a = "category_title-3VpWX";
var _1b = "category_description-O473d";
var _1c = "promoMessage-_BWT7";
var _1d = "included_baggage-zFMpG";
var _1e = "toggle__wrapper-25EKd";
var _1f = "descriptionContainer-T1Qvl";
var _20 = "baggageInfo-20CDE";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet_only", _4 as "description", _5 as "info", _6 as "equipment", _7 as "info_price", _8 as "titleContainer", _9 as "baggage_wrapper", _a as "label", _b as "price_wrapper", _c as "perFlight", _d as "price_label", _e as "price_label_withPrice", _f as "price_amount", _10 as "row", _11 as "baggage__container", _12 as "baggage__container_withSlider", _13 as "baggage__slider", _14 as "segmentNotice", _15 as "categories", _16 as "categories__item", _17 as "category__wrapper", _18 as "category__price", _19 as "category_info", _1a as "category_title", _1b as "category_description", _1c as "promoMessage", _1d as "included_baggage", _1e as "toggle__wrapper", _1f as "descriptionContainer", _20 as "baggageInfo" }
export default { "__esModule": _1, "mobile": _2, "tablet_only": _3, "description": _4, "info": _5, "equipment": _6, "info_price": _7, "titleContainer": _8, "baggage_wrapper": _9, "label": _a, "price_wrapper": _b, "perFlight": _c, "price_label": _d, "price_label_withPrice": _e, "price_amount": _f, "row": _10, "baggage__container": _11, "baggage__container_withSlider": _12, "baggage__slider": _13, "segmentNotice": _14, "categories": _15, "categories__item": _16, "category__wrapper": _17, "category__price": _18, "category_info": _19, "category_title": _1a, "category_description": _1b, "promoMessage": _1c, "included_baggage": _1d, "toggle__wrapper": _1e, "descriptionContainer": _1f, "baggageInfo": _20 }
